var map = {
	"./business-01.jpg": 51433,
	"./business-02.jpg": 24702,
	"./business-03.jpg": 56187,
	"./business-04.jpg": 26184,
	"./team-1.jpg": 72558,
	"./team-2.jpg": 71225,
	"./team-3.jpg": 43228,
	"./team-4.jpg": 97639,
	"./team-5.jpg": 85482
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 58927;